<template>
  <div class="content">
      <div class="search-area" :style="height">
                <el-button plain size="medium" v-if="!addSh" @click="add">数据生成</el-button> 
                <div v-else style="background: #cccccc !important; width: 98px;height: 36px;line-height: 36px;border-radius: 4px;color: #4fa1a4;margin: 0 auto">数据生成</div> 
                <div class="mt15">生成时间:{{time | getDate}}</div>
                <el-progress :text-inside="true" class="mt15" :stroke-width="15" :percentage="percentage"></el-progress>
      </div> 
      
  </div>
</template>

<script>
import {route}  from '@/api/apiRoute';
import store from '@/store'
export default {
  data() {
    return { 
      url:`/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
        token:{
          'Content-Type': 'multipart/form-data',
          'Authorization':store.state.token
        },
      active: 0,
     srcs: '', 
     winHeight: window.innerHeight,
      height: {
        height: '',
      },
      time:'',
      percentage:0,
      interval:'',
      addSh:false,
    };
  },
  created() {  
    
  },   
  watch: {  
  },
  mounted(){    
  window.onresize = () => { 
    return (() => { 
    this.winHeight = window.innerHeight 
        })
    } 
    this.height.height=this.winHeight-130+'px'; 
  }, 
  methods: {
      add(){
              this.addSh = true;
              this.percentage = 0;
              if(this.percentage == 0){
                     this.interval = setInterval(this.percentageSh,"10"); 
              }
              this.upDateAdd();
      }, 
      close(){ 
          clearInterval(this.interval) 
      },
      percentageSh(){ 
            if(this.percentage <= 99){
                  this.percentage++;
            }else{  
                      this.addSh = false;  
            }
      },
      upDateAdd() {
      let self = this; 
      self.time = '';
      self.api.put('/ms-user-scm-service/demon/update-date-to-now').then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.time = res.data.data;
          // self.$message.success('数据生成');
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script>
<style  scoped>
/deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color:#4fa1a4;
    border-color: inherit;
}
/deep/ .el-step__icon-inner {
    color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
    color: #4fa1a4;
}
</style>